module.exports = __webpack_public_path__ + "static/img/cancersrt.03fc53f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cancersrt.png
// module id = SR+N
// module chunks = 1